import { SelectAvailability } from "./select-availability.model";
import { SelectImage } from "./select-image.model";

export class SelectCurrency extends SelectImage {
    symbol: string | null = null;
    sellRate: number | null = null;
    sellRateReverse: number | null = null;
    denominationMin: number | null = null;
    availability: SelectAvailability | null = null
}
